class NotificationPopup extends HTMLElement {
  connectedCallback() {
    this.popup = document.querySelector(".not-pu-section");
    if (!this.popup) return;

    this.closeBtn = this.popup.querySelector(".newsletter__close-btn");
    this.hasSubscription = this.dataset.hasSubscription === "true";
    this.delay = Number(this.dataset.delay) || 0;
    this.cookie = document.cookie.includes("hideNotificationPopup=true");

    // 1. Sprawdzamy, czy w linku są automatyczne parametry z Shopify Email
    const params = new URLSearchParams(window.location.search);
    const isFromEmail = params.get("utm_medium") === "email" || params.get("utm_source") === "shopify_email";

    // 2. Sprawdzamy, czy formularz został przed chwilą pomyślnie wysłany
    const isSuccessful = this.querySelector('.form__success-field') !== null;

    // Jeśli klient kliknął link w newsletterze LUB właśnie zapisał się na stronie:
    if (isFromEmail || isSuccessful) {
      // Wgrywamy ciasteczko na 30 dni, żeby popup nie wyskakiwał podczas dalszego przeglądania sklepu
      this.setCookie("hideNotificationPopup", "true", 30);
      return; 
    }

    // Standardowa blokada (dla zalogowanych subskrybentów lub osób z ciasteczkiem)
    if (this.hasSubscription || this.cookie) return;

    // Wyświetlenie popupu po określonym czasie
    setTimeout(() => {
      this.popup.classList.remove("hidden");
      this.popup.classList.add("wt-popup-fade-in");
    }, this.delay * 1000);

    // Zamykanie popupu
    this.closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.popup.classList.add("hidden");
      this.setCookie("hideNotificationPopup", "true", 7);
    });
  }

  setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
  }
}

customElements.define("notification-popup", NotificationPopup);